import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sidebar-widget style4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://tawk.to/lapostebenineservice",
      target: "_blank",
      class: "btn btn-sm style1"
    }, "Discuter avec un agent")
  ])
], -1)
const _hoisted_3 = { class: "sidebar-widget categories" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "Nouvelles catégories", -1)
const _hoisted_5 = { class: "category-box" }
const _hoisted_6 = { class: "list-style" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "ri-login-box-line" }, null, -1)
const _hoisted_8 = { class: "sidebar-widget popular-post" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", null, "Autres articles", -1)
const _hoisted_10 = { class: "popular-post-widget" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "pp-post-info" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar" }, null, -1)
const _hoisted_14 = { class: "sidebar-widget tags" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", null, "Tags populaires ", -1)
const _hoisted_16 = { class: "tag-list" }
const _hoisted_17 = { class: "list-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categorieArticles, (categorie, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(_component_router_link, { to: "#" }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(categorie.nom), 1)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "pp-post-item",
            key: index
          }, [
            (article?.urlImage)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "#",
                  class: "pp-post-img"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.getUrlApiForFiles(article.urlImage),
                      alt: "Image"
                    }, null, 8, _hoisted_11)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", null, [
                _hoisted_13,
                _createTextVNode(_toDisplayString(_ctx.format_Date(article.datePublication)), 1)
              ]),
              _createElementVNode("h6", null, [
                _createVNode(_component_router_link, { to: "blog-details" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(article.titre), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("ul", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(_component_router_link, { to: "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag.nom), 1)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}